import React, { useRef, useState } from 'react'
import { Fade as Hamburger } from 'hamburger-react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'

// Hooks
import useOnClickOutside from '../hooks/useOnClickOutside'

// Components
import Dropdown from './dropdown'
import Search from './search'
import BidJSMenu from './bidjsMenu'

const Header = ({ uid }) => {
  const staticData = useStaticQuery(graphql`
    {
      prismicNavigation {
        ...PrismicNavigationFragment
      }
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const data = useMergePrismicPreviewData(staticData)
  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))

  const [isOpen, setOpen] = useState(false)
  const navStyles =
    'flex w-full border-b-2 border-transparent py-2 px-5 text-xl text-gray-800 ring-orange-400 transition duration-150 ease-linear hover:border-blue-900 hover:text-blue-900 focus:text-blue-800 lg:w-auto lg:px-2 lg:text-lg items-center justify-between lg:justify-start'
  const subNavStyles = 'py-2 px-5 text-gray-800 transition duration-150 ease-linear hover:text-blue-900 focus:text-blue-800 flex hover:bg-blue-50 lg:px-6'

  const headerData = data.prismicNavigation.data
  const configData = data.prismicConfig.data
  return (
    <>
      <header role='banner' className='relative z-20 bg-white shadow-sm xl:mb-5'>
        <nav ref={ref} id='navigation' className='mx-auto flex max-w-screen-xl items-center justify-between p-2'>
          <PrismicLink href='/' className={`w-60 ring-orange-400 ${isOpen ? 'fixed top-1 py-2 z-40 bg-white' : 'relative'}`}>
            <GatsbyImage
              loading='eager'
              placeholder='none'
              height='58'
              width='240'
              image={configData.company_logo.gatsbyImageData}
              alt={configData.company_logo.alt || configData.company_display_name}
            />
          </PrismicLink>
          <span className={`${isOpen ? 'fixed right-1 top-1 z-20 p-3 bg-white rounded' : ''} text-gray-500 lg:hidden`}>
            <Hamburger color='currentColor' label='Show menu' rounded toggled={isOpen} toggle={setOpen} />
          </span>
          <div className={`${!isOpen ? 'tw-hidden lg:block' : 'fixed inset-0 z-10 flex h-screen flex-col justify-start bg-black bg-opacity-25 p-1'} lg:h-auto lg:flex-row lg:bg-transparent`}>
            <div className='pt-20 max-h-screen overflow-y-scroll rounded-md bg-white lg:flex lg:h-full lg:w-full lg:items-center lg:justify-end lg:overflow-y-visible lg:bg-transparent lg:p-0 lg:pt-0'>
              <ul className='divide-y divide-gray-100 lg:mt-0 lg:flex lg:h-full lg:w-full lg:items-center lg:justify-end lg:space-x-3 lg:divide-none lg:p-0 lg:pt-0'>
                {headerData.nav.map((nav, index) => {
                  return (
                    <React.Fragment key={`nav-${index}`}>
                      {nav.items.length > 1 ? (
                        <Dropdown items={nav.items} navStyles={navStyles} subNavStyles={subNavStyles}>
                          {nav.primary.label}
                        </Dropdown>
                      ) : (
                        <li key={`nav-${index}`}>
                          <PrismicLink className={navStyles} href={nav.primary.link.url}>
                            {nav.primary.label}
                          </PrismicLink>
                        </li>
                      )}
                    </React.Fragment>
                  )
                })}
                <li className='x-bidlogix--authenticated-hide'>
                  <PrismicLink href='/auction/#!/account' onClick={() => setOpen(false)} className={navStyles}>
                    {configData.create_account || 'Create Account'}
                  </PrismicLink>
                </li>
                <li className='x-bidlogix--authenticated-hide'>
                  <PrismicLink href='/auction/#!/login' onClick={() => setOpen(false)} className='button button-brand block rounded-t-none text-xl lg:rounded lg:text-lg xl:inline-block'>
                    {configData.login || 'Log In'}
                  </PrismicLink>
                </li>
                <BidJSMenu navStyles={navStyles} subNavStyles={subNavStyles} />
              </ul>
            </div>
          </div>
        </nav>
      </header>
      {(uid === 'index' || uid === 'auction') && (
        <div className='mx-auto w-full max-w-3xl px-3 pb-3 mt-4 xl:mt-0 md:pb-5'>
          <Search />
        </div>
      )}
    </>
  )
}

export default Header
